import React from 'react';
import debounce from 'lodash/debounce';

const isClient = typeof window === 'object';

function getSize(): { windowWidth: number; windowHeight: number } {
  return {
    windowWidth: isClient ? window.innerWidth : -1,
    windowHeight: isClient ? window.innerHeight : -1,
  };
}

export const useWindowSize = () => {
  const [size, setSize] = React.useState(getSize);

  const onResize = debounce(() => setSize(getSize), 50);

  React.useEffect(() => {
    if (!isClient) {
      return;
    }

    window.addEventListener('resize', onResize, true);

    return () => window.removeEventListener('resize', onResize, true);
  }, []);

  return size;
};

export const useOrientationChange = () => {
  if (!isClient) return 'portrait';

  const [orientation, setOrientation] = React.useState(
    window.innerWidth >= window.innerHeight ? 'landscape' : 'portrait'
  );

  const onResize = debounce(
    () =>
      setOrientation(
        window.innerWidth >= window.innerHeight ? 'landscape' : 'portrait'
      ),
    50
  );

  React.useEffect(() => {
    window.addEventListener('orientationchange', onResize, true);

    return () =>
      window.removeEventListener('orientationchange', onResize, true);
  }, []);

  return orientation;
};
